<!-- <p-toast></p-toast> -->
<!-- <p-toast position="top-center" [autoZIndex]="true"></p-toast> -->

<app-header-style-seven></app-header-style-seven>

<!-- <div>
    <button class="btn btn-success" (click)="onSubmit()">Send mail</button>
</div> -->

<div id="">
    <app-homethirteen-main-banner></app-homethirteen-main-banner>
</div>

<div id="axes">
    <app-homethirteen-popular-courses></app-homethirteen-popular-courses>
</div>

<!-- <app-features-stye-three></app-features-stye-three> -->

<div id="about">
    <app-homethirteen-about></app-homethirteen-about>
</div>

<!-- <div class="motivation-partner-area bg-color-with-gradient ptb-100">
    <div class="container">
        <app-partner-style-one></app-partner-style-one>
    </div>
</div> -->
<!-- background-color: #F0C04A; -->
<!-- <div class="overview-connections-area pt-100 pb-70">
    <app-make-connections></app-make-connections>
</div> -->

<!-- <div id="offers">
    <app-homethirteen-courses></app-homethirteen-courses>
</div> -->

<!-- <app-instructors-style-four></app-instructors-style-four> -->

<div class="">
    <app-happy-students-feedback></app-happy-students-feedback>
</div>

<div id="join">
    <app-become-partner-teacher></app-become-partner-teacher>
</div>

<app-faq></app-faq>

<!-- dann bilzariane -->